import { FaCircle } from "react-icons/fa";
import "../styles/results.css";

function Results() {
  const results = [
    {
      text: "Több megrendelést, hogy a vállalkozásod ne csak fenntartható legyen, hanem folyamatosan növekedjen.",
    },
    {
      text: "Magasabb életszínvonalat – mert a bevételnövekedés nem cél, hanem eszköz ahhoz, hogy szabadabban élhess.",
    },
    {
      text: "Kevesebb operatív teher, több szabadidő – ha már mindent megteszel az ügyfeleidért, megérdemled, hogy ne a napi túlélésről szóljon a vállalkozásod.",
    },
  ];

  return (
    <section id="results" className="results-section">
      <div className="container pb-3">
        {/* Centered title above the row */}

        <div className="row align-items-center g-5 flex-column-reverse flex-md-row">
          {/* Left column - results */}
          <div className="col-md-6">
            <h2 className="results-title mb-5 text-center">
              Akkor tudok segíteni, ha a következőket akarod elérni:
            </h2>
            <ul className="results-list">
              {results.map((item, index) => (
                <li key={index} className="results-item d-flex mb-1">
                  <span className="results-icon">
                    <FaCircle size={10} />
                  </span>
                  <span className="results-text py-2">{item.text}</span>
                </li>
              ))}
            </ul>

            <div className="text-center mt-4">
              <a
                href="#contact"
                className="btn btn-light btn-lg px-4 results-button"
              >
                Vágjunk bele!
              </a>
            </div>
          </div>

          {/* Right column - image */}
          <div className="col-md-6 text-center">
            <img
              src="/images/results.webp"
              alt="Eredmények: több megrendelés, magasabb életszínvonal, kevesebb operatív teher"
              className="result-image"
              loading="lazy"
              decoding="async"
              width="900"
              height="640"
            />
          </div>
        </div>
      </div>
      <div className="curved-divider">
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
          <path
            fill="#ffffff"
            d="M0,70 C360,100 1080,0 1440,70 L1440,100 L0,100 Z"
          />
        </svg>
      </div>
    </section>
  );
}

export default Results;
